import { Pencil, Trash2, Eye, EyeOff, ExternalLink } from "lucide-react";
import { ADMIN } from "@/constants/testIds";
import { API } from "@/lib/api";

const RECO_STYLES = {
  Buy: "bg-green-100 text-green-700",
  Sell: "bg-red-100 text-red-700",
};

/** Reports table for a section's admin list view. */
export function ReportsTable({ reports, loading, search, onToggleStatus, onEdit, onDeleteRequest }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">Company</th>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">Sector</th>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">KIRA Score</th>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">Reco</th>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">Report Date</th>
            <th className="text-left px-4 py-2.5 font-medium text-gray-500">Status</th>
            <th className="text-right px-4 py-2.5 font-medium text-gray-500">Actions</th>
          </tr>
        </thead>
        <tbody>
          {!loading && reports.map((r) => (
            <tr key={r.id} data-testid={`${ADMIN.reportRow}-${r.slug}`} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="px-4 py-2.5">
                <div className="flex items-center gap-2">
                  <div className="flex h-7 w-7 items-center justify-center rounded bg-gray-100 overflow-hidden shrink-0">
                    {r.logo_media_id
                      ? <img src={`${API}/files/${r.logo_media_id}`} alt="" className="h-full w-full object-cover" />
                      : <span className="text-[11px] font-bold text-gray-400">{r.company_name.charAt(0)}</span>}
                  </div>
                  <span className="text-gray-900 font-medium">{r.company_name}</span>
                  {r.symbol && <span className="font-mono text-[10px] text-gray-400">{r.symbol}</span>}
                  {r.status === "published" && (
                    <a href={`/company/${r.slug}`} target="_blank" rel="noreferrer"
                      className="text-gray-300 hover:text-gray-600" title="View on site">
                      <ExternalLink className="h-3.5 w-3.5" />
                    </a>
                  )}
                </div>
              </td>
              <td className="px-4 py-2.5 text-gray-600">{r.sector}</td>
              <td className="px-4 py-2.5 font-mono text-gray-900">{r.kira_score}</td>
              <td className="px-4 py-2.5">
                <span className={`rounded px-1.5 py-0.5 text-[11px] font-mono font-semibold ${RECO_STYLES[r.recommendation] || "bg-amber-100 text-amber-700"}`}>
                  {r.recommendation || "Hold"}
                </span>
              </td>
              <td className="px-4 py-2.5 font-mono text-xs text-gray-500">{r.report_date}</td>
              <td className="px-4 py-2.5">
                <span className={`rounded px-2 py-0.5 text-[11px] font-medium capitalize ${r.status === "published" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>
                  {r.status}
                </span>
              </td>
              <td className="px-4 py-2.5 text-right whitespace-nowrap">
                <button data-testid={`${ADMIN.toggleStatusButton}-${r.slug}`} onClick={() => onToggleStatus(r)}
                  className="text-gray-400 hover:text-gray-900 p-1.5" title={r.status === "published" ? "Unpublish" : "Publish"}>
                  {r.status === "published" ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
                <button data-testid={`${ADMIN.editButton}-${r.slug}`} onClick={() => onEdit(r)}
                  className="text-gray-400 hover:text-gray-900 p-1.5"><Pencil className="h-4 w-4" /></button>
                <button data-testid={`${ADMIN.deleteButton}-${r.slug}`} onClick={() => onDeleteRequest(r)}
                  className="text-gray-400 hover:text-red-600 p-1.5"><Trash2 className="h-4 w-4" /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!loading && reports.length === 0 && (
        <p className="text-center text-sm text-gray-400 py-12">
          {search ? "No reports match your search." : "No reports yet. Click \"Publish New Report\" to add the first one."}
        </p>
      )}
    </div>
  );
}
